(function () {
    'use strict';

    angular.module("imApp").factory("selectOeeStateRemarkService", ['$ihttp', function ($ihttp) {
        let service = {
            rememberingToPreOeeData: false,
            listRemarks: function (parms) {
                return $ihttp.post({
                    method: 246,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
